<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Datos del lugar, paisaje y manejo de los perros</h4>
    <form-group :error="errors.has('lugarDepredacion') && submitted">
      <label class="form__label form__label--required">
        7. El evento de depredación fue en:
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.lugarDepredacion"
        id="unaCasa"
        name="lugarDepredacion"
        v-validate="'required'"
        value="Una casa">
        <label class="form__label" for="unaCasa">Una casa</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.lugarDepredacion"
        id="centroTuristicoHotel"
        name="lugarDepredacion"
        v-validate="'required'"
        value="Centro turístico/hotel">
        <label class="form__label" for="centroTuristicoHotel">Centro turístico/hotel</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.lugarDepredacion"
        id="granjaAvicola"
        name="lugarDepredacion"
        v-validate="'required'"
        value="Una finca">
        <label class="form__label" for="granjaAvicola">
          Una finca
        </label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('nombre-lugar-depredacion') && submitted"
        v-if="form.body.lugarDepredacion === 'Una finca'
        || form.body.lugarDepredacion === 'Centro turístico/hotel'">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.body.nombreLugarDepredacion"
          name="nombre-lugar-depredacion"
          required
          v-validate="'required'">
          <label class="form__label">
            {{form.body.lugarDepredacion === 'Una finca' ?
            'Nombre de la finca' :
            'Nombre del centro turístico/hotel'}}
          </label>
        </form-group>
      </div>
    </form-group>

    <label class="form__label form__label--required">
      8. Nombre y teléfono del dueño del perro
    </label>
    <form-group :error="errors.has('nomDuenoPerro') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.nomDuenoPerro"
      name="nomDuenoPerro"
      required
      v-validate="'required'">
      <label class="form__label" for="nomDuenoPerro">
        Nombre
      </label>
    </form-group>
    <form-group :error="errors.has('telDuenoPerro') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.telDuenoPerro"
      name="telDuenoPerro"
      required
      v-validate="'required'">
      <label class="form__label" for="telDuenoPerro">
        Teléfono
      </label>
    </form-group>

    <form-group :error="errors.has('nombre-entrevistado')">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.nombreEntrevistado"
      name="nombre-entrevistado"
      required
      v-validate="'required'">
      <label class="form__label">
        9. Nombre de la persona que nos atendió
      </label>
    </form-group>

    <div class="identado">
      <form-group :error="errors.has('telefono-entrevistado') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.telefonoEntrevistado"
        name="telefono-entrevistado"
        required
        v-validate="'required'">
        <label class="form__label">9.1. Teléfono de la persona que nos atendió</label>
      </form-group>
    </div>

    <div>
      <label class="form__label form__label--required">
        10. Ubicación geográfica
      </label>
      <div class="identado">
        <form-group :error="errors.has('provincia') && submitted">
          <select
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.provincia"
          name="provincia"
          required
          v-validate="'required'">
            <option value="" selected="true" disabled="disabled">--Provincia--</option>
            <option :value="key"
            v-for="(value, key) in provincias" :key="key">{{key}}</option>
          </select>
          <label class="form__label">Provincia</label>
        </form-group>
        <form-group :error="errors.has('canton') && submitted">
          <select
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.canton"
          name="canton"
          required
          v-validate="'required'">
            <option value="" selected="true" disabled="disabled">--Canton--</option>
            <option :value="canton"
            v-for="canton in provincias[form.ubicacion.provincia]" :key="canton">{{canton}}</option>
          </select>
          <label class="form__label">Cantón</label>
        </form-group>
        <form-group :error="errors.has('distrito') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.distrito"
          name="distrito"
          required
          v-validate="'required'">
          <label class="form__label">Distrito</label>
        </form-group>
        <form-group :error="errors.has('caseriaPueblo') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.caserio"
          name="caseriaPueblo"
          required
          v-validate="'required'">
          <label class="form__label">Caserío/pueblo</label>
        </form-group>
        <form-group :error="errors.has('direccion') && submitted">
          <textarea
          data-vv-validate-on="blur"
          v-if="editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.direccion"
          name="direccion"
          required
          v-validate="'required'"/>
          <p v-else class="text">{{form.ubicacion.direccion}}</p>
          <label class="form__label form__label--required">Dirección exacta del lugar</label>
        </form-group>
      </div>
    </div>

    <form-group :error="errors.has('ingresaAlBosque') && submitted">
      <label class="form__label form__label--required">
        11. El perro tiene la costumbre de ingresar al bosque?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.ingresaAlBosque"
        id="siingresaAlBosque"
        name="ingresaAlBosque"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="siingresaAlBosque">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.ingresaAlBosque"
        id="noingresaAlBosque"
        name="ingresaAlBosque"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="noingresaAlBosque">
          No
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('estadoUsual') && submitted">
      <label class="form__label form__label--required">
        12. El perro está la mayoría del tiempo
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.estadoUsual"
        id="amarradoestadoUsual"
        name="estadoUsual"
        v-validate="'required'"
        value="Amarrado">
        <label class="form__label" for="amarradoestadoUsual">
          Amarrado
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.estadoUsual"
        id="sueltoestadoUsual"
        name="estadoUsual"
        v-validate="'required'"
        value="Suelto">
        <label class="form__label" for="sueltoestadoUsual">
          Suelto
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.estadoUsual"
        id="encierroestadoUsual"
        name="estadoUsual"
        v-validate="'required'"
        value="En un encierro">
        <label class="form__label" for="encierroestadoUsual">
          En un encierro
        </label>
      </div>
    </form-group>

    <form-group class="identado" :error="errors.has('estadoDiaAtaque') && submitted">
      <label class="form__label form__label--required">
        12.1 El día del ataque el perro estaba
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.estadoDiaAtaque"
        id="amarradoestadoDiaAtaque"
        name="estadoDiaAtaque"
        v-validate="'required'"
        value="Amarrado">
        <label class="form__label" for="amarradoestadoDiaAtaque">
          Amarrado
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.estadoDiaAtaque"
        id="sueltoestadoDiaAtaque"
        name="estadoDiaAtaque"
        v-validate="'required'"
        value="Suelto">
        <label class="form__label" for="sueltoestadoDiaAtaque">
          Suelto
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.estadoDiaAtaque"
        id="encierroestadoDiaAtaque"
        name="estadoDiaAtaque"
        v-validate="'required'"
        value="Dentro del encierro">
        <label class="form__label" for="encierroestadoDiaAtaque">
          Dentro del encierro
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('dentro-asp') && submitted">
      <label class="form__label form__label--required">
        13. ¿La propiedad está dentro de alguna ASP?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.dentroASP"
        id="sidentroASP"
        name="dentro-asp"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="sidentroASP">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.dentroASP"
        id="nodentroASP"
        name="dentro-asp"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="nodentroASP">No</label>
      </div>
      <div class="identado" v-if="form.body.dentroASP === true">
        <form-group :error="errors.has('nombre-asp') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.body.nomASP"
          name="nombre-asp"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Cuál ASP?
          </label>
        </form-group>
      </div>
      <div class="identado">
        <form-group :error="errors.has('nombre-asp') && submitted"
        v-if="form.body.dentroASP === false">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.body.nomASP"
          name="nombre-asp"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Cuál es la ASP más cercana a la propiedad?
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('hay-barreras') && submitted">
      <label class="form__label form__label--required">
        14. ¿Existen cercas/barreras que separen el área donde vive el perro del bosque?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayBarreras"
        id="sihayBarreras"
        name="hay-barreras"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="sihayBarreras">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayBarreras"
        id="nohayBarreras"
        name="hay-barreras"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="nohayBarreras">No</label>
      </div>
    </form-group>

    <form-group class="identado" :error="errors.has('hayBarrerasTipo') && submitted"
    v-if="form.body.hayBarreras">
      <label class="form__label form__label--required">
        ¿De qué tipo?
      </label>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando" type="checkbox" id="puastipoBarreras" v-validate="'required'"
        v-model="form.body.tipoBarreras" value="Púas" name="hayBarrerasTipo">
        <label class="form__label" for="puastipoBarreras">Púas</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando" type="checkbox" id="electricastipoBarreras" v-validate="'required'"
        v-model="form.body.tipoBarreras" value="Eléctricas" name="hayBarrerasTipo">
        <label class="form__label" for="electricastipoBarreras">Eléctricas</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando" type="checkbox" id="cercaNaturaltipoBarreras" v-validate="'required'"
        v-model="form.body.tipoBarreras" value="Cerca natural" name="hayBarrerasTipo">
        <label class="form__label" for="cercaNaturaltipoBarreras">Cerca natural</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando" type="checkbox" id="mallaGanaderatipoBarreras" v-validate="'required'"
        v-model="form.body.tipoBarreras" value="Malla ganadera" name="hayBarrerasTipo">
        <label class="form__label" for="mallaGanaderatipoBarreras">Malla ganadera</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando" type="checkbox" id="otratipoBarreras" v-validate="'required'"
        v-model="form.body.tipoBarreras" value="Otra" name="hayBarrerasTipo">
        <label class="form__label" for="otratipoBarreras">Otro / Comentarios adicionales</label>
      </div>
      <form-group :error="errors.has('otro-tipo-barrera') && submitted"
      v-if="form.body.tipoBarreras.includes('Otra')">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.otroTipoBarrera"
        name="otro-tipo-barrera"
        required
        v-validate="'required'">
        <label class="form__label">
          Especifique cual otra:
        </label>
      </form-group>
    </form-group>

    <form-group :error="errors.has('disponibilidad-madera') && submitted">
      <label class="form__label form__label--required">
        15. ¿Hay disponibilidad de madera resistente en la propiedad?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.disponibilidadMadera"
        id="sidisponibilidadMadera"
        name="disponibilidad-madera"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="sidisponibilidadMadera">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.disponibilidadMadera"
        id="nodisponibilidadMadera"
        name="disponibilidad-madera"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="nodisponibilidadMadera">No</label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('tipos-madera') && submitted"
        v-if="form.body.disponibilidadMadera">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.body.tipoMaderaDisponible"
          name="tipos-madera"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Qué tipos/especies hay?
          </label>
        </form-group>
      </div>
    </form-group>

  </form>
</template>

<script>
import provincias from "../../comunes/cr-division-politica.json";

export default {
  name: "FormPerrosBloque2",
  data() {
    return {
      provincias,
    };
  },
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
